/**
 * Library category config
 *
 * KPIs: totalBooksHindi, totalBooksEnglish, totalBooksDigitalHindi,
 *       totalBooksDigitalEnglish, libraryAutomationSystem,
 *       libraryAutomationSystemName, internateAvailableInLibrary,
 *       studentSeatingCapacity, libraryBlogAddress
 */
import type { CategoryConfig } from './CategoryConfig';

export const libraryConfig: CategoryConfig = {
  categoryKey: 'libraryProfile',
  label: 'Library',
  priority: 6,

  columns: {
    defaultVisibleColumns: [
      'schoolName', 'stateName', 'roName',
      'totalBooksHindi', 'totalBooksEnglish',
      'studentSeatingCapacity', 'libraryAutomationSystem',
    ],
  },
};
